export default "__VITE_ASSET__247aa89f__"